import fetch from '@/utils/sys_fetch'

export function login({account, companyCode, password}) {
  return fetch({
    url: 'enterprise.login',
    method: 'post',
    data: {
      data: {account, companyCode, password}
    }
  })
}

export function loginOut({data}) {
  return fetch({
    url: 'enterprise.loginOut',
    method: 'post',
    data: {
      data
    }
  })
}

export function getLoginInfoByToken ({token}) {
  return fetch({
    url: `/pos/getLoginInfoByToken`,
    method: 'post',
    data: {
      data: {
        token
      }
    }
  })
}
export function companyWechatAuthCode (data) {
  return fetch({
    url: `/companyWechatAuthCode.add`,
    method: 'post',
    data: {
      data
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/management/v2/login.js